import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { MuiOtpInput } from 'mui-one-time-password-input';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Loader from './../common/Loader';

import Helpers from '../utility/Helpers';
import {
  Initiate2FAOTP,
  ResetPasswordOTP,
  OtpEmailValidation,
  ValidateUserEmail,
  ValidateOtp,
} from '../services/AccountService';
// import { Label } from "@mui/icons-material";

function InitiateOTP(props) {
  const navigate = useNavigate();
  let dispatch = useDispatch();
  let textInputUser = React.createRef();
  let textInputNewPassword = React.createRef();
  let textInputConfirmNewPassword = React.createRef();
  let textOtp = React.createRef();
  const [emailAlreadyThere, setEmailAlreadyThere] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [otpInitiationType, setOtpInitiationType] = useState(2);
  const [otp, setOtp] = React.useState('');
  const [emailConfirmed, setEmailConfirmed] = React.useState(false);
  const [otpInitiated, setOtpInitiated] = React.useState(false);
  const [passwordConfirmed, setPasswordConfirmed] = React.useState(false);
  const [otpConfirmed, setOtpConfirmed] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [displayResendButton, setDisplayResendButton] = React.useState(true);
  const [timerOn, setTimerOn] = React.useState(true);
  const [timerDisplay, setTimerDisplay] = React.useState(false);
  const [timeRemaining, setTimeRemaining] = React.useState('');
  useEffect(() => {
    //sessionStorage.setItem('userEmail', 'dipak@groundup.tech');
    const uEmail = sessionStorage.getItem('userEmail');
    if (uEmail !== null && uEmail !== '') {
      setUserEmail(uEmail);
      setEmailAlreadyThere(true);
    }
    const otpIniType = sessionStorage.getItem('otpInitiationType');
    if (otpIniType !== null && otpIniType !== '') {
      setOtpInitiationType(parseInt(otpIniType));
    }
  }, [emailAlreadyThere, userEmail, otpInitiationType]);

  function timer(remaining) {
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;

    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;
    setTimeRemaining(m + ':' + s);
    remaining -= 1;

    if (remaining >= 0 && timerOn) {
      setTimeout(function () {
        timer(remaining);
      }, 1000);
      return;
    }

    if (!timerOn) {
      // Do validate stuff here
      return;
    }

    // Do timeout stuff here
    setTimerDisplay(false);
  }

  const tryOTPMFA = async () => {
    if (!emailConfirmed) {
      if (textInputUser.current.value === '') {
        Helpers.handleError('User Email is required');
        textInputUser.current.focus();
        return;
      } else if (!Helpers.isValidEmail(textInputUser.current.value)) {
        Helpers.handleError('Input a valid email');
        textInputUser.current.focus();
        return;
      }
      //on valid email
      setIsLoading(true);
      await Initiate2FAOTP(userEmail, otpInitiationType)
        .then((res) => {
          var responsedata = res.data;
          setEmailConfirmed(true);
          setOtpInitiated(true);
          //setResendOtpSeconds(responsedata.time);
          setTimerDisplay(true);
          timer(parseInt(responsedata.time));
          Helpers.handleSuccess(res.message);
          setIsLoading(false);
          return;
        })
        .catch((error) => {
          Helpers.handleError(error);
          setIsLoading(false);
        });
      return;
    } else if (!otpConfirmed && otpInitiated) {
      //ValidateOtp
      if (otp.length < 6) {
        Helpers.handleError('Input 6-digit OTP');
        return;
      }
      setIsLoading(true);
      await ValidateOtp(userEmail, otp, otpInitiationType)
        .then((res) => {
          // log var responsedata=res.data;
          if (otpInitiationType === 1) {
            Helpers.handleSuccess(res.message);
            setIsLoading(false);
            setTimeout(navigate('/'), 500);
          }
          setOtpConfirmed(true);
          var timeMinuts = parseInt(res.data !== null ? res.data : '0'); //timer required ?
          Helpers.handleSuccess(res.message);
          setIsLoading(false);
        })
        .catch((error) => {
          Helpers.handleError(error);
          setIsLoading(false);
        });
    } else if (!passwordConfirmed && otpConfirmed) {
      //validation new password
      // return on invalid
      if (newPassword !== confirmNewPassword) {
        Helpers.handleError('New password and confirm password did not match');
        return;
      }
      setIsLoading(true);
      await ResetPasswordOTP(userEmail, otp, confirmNewPassword, 2)
        .then((res) => {
          // log var responsedata=res.data;
          Helpers.handleSuccess(res.message);
          setIsLoading(false);
          setTimeout(navigate('/'), 500);
        })
        .catch((error) => {
          Helpers.handleError(error);
          setIsLoading(false);
        });
    }
  };
  const resendOTP = async () => {
    setIsLoading(true);
    await Initiate2FAOTP(userEmail, otpInitiationType)
      .then((res) => {
        var responsedata = res.data;
        Helpers.handleSuccess(res.message);
        setIsLoading(false);
        setTimerDisplay(true);
        timer(parseInt(responsedata.time));
        return;
      })
      .catch((error) => {
        Helpers.handleError(error);
        setIsLoading(false);
      });
  };
  const cancelAction = async () => {
    setTimeout(navigate('/'), 500);
  };
  const handleEmailChange = (val) => {
    setUserEmail(val.target.value);
  };
  const handleNewPasswordChange = (val) => {
    setNewPassword(val.target.value);
  };
  const handleConfirmNewPasswordChange = (val) => {
    setConfirmNewPassword(val.target.value);
  };
  const handleOTPChange = (newValue) => {
    setOtp(newValue);
  };
  const disableOnTrue = (flag) => {
    return {
      pointerEvents: flag ? 'none' : 'initial',
    };
  };
  const getHeadingText = () => {
    if (otpInitiationType === 1 && !emailConfirmed) return 'EMAIL VALIDATION';
    else if (otpInitiationType === 1 && emailConfirmed)
      return 'OTP VERIFICATION';
    else if (otpInitiationType === 2 && !emailConfirmed)
      return 'PASSWORD RESET';
    else if (
      otpInitiationType === 2 &&
      emailConfirmed &&
      !passwordConfirmed &&
      !otpConfirmed
    )
      return 'OTP VERIFICATION';
    else return 'PASSWORD RESET';
  };
  const getSubHeadingText = () => {
    if (otpInitiationType === 1 && !emailConfirmed)
      return 'Please verify your email below';
    else if (otpInitiationType === 1 && emailConfirmed)
      return "We've just sent a 6-digit code to your email: " + userEmail;
    else if (otpInitiationType === 2 && !emailConfirmed)
      return 'Please verify your email below';
    else if (
      otpInitiationType === 2 &&
      emailConfirmed &&
      !passwordConfirmed &&
      !otpConfirmed
    )
      return "We've just sent a 6-digit code to your email: " + userEmail;
    else return 'Input new password';
  };
  // function GradientCircularProgress() {
  //   return (
  //     <React.Fragment>
  //       <svg width={0} height={0}>
  //         <defs>
  //           <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
  //             <stop offset="0%" stopColor="#e01cd5" />
  //             <stop offset="100%" stopColor="#1CB5E0" />
  //           </linearGradient>
  //         </defs>
  //       </svg>
  //       <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
  //     </React.Fragment>
  //   );
  // };

  return (
    <>
      <Box className="bg-login-image">
        <AppBar
          position="fixed"
          sx={{
            width: '100%',
          }}
        >
          <Toolbar>
            <Box
              component="img"
              alt="Org Image"
              src={process.env.PUBLIC_URL + '/images/blank.png'}
            />
            <Box
              component="img"
              sx={
                {
                  //height: 80,
                  //maxHeight: { xs: 100, md: 90 },
                }
              }
              alt="Org Image"
              src={process.env.PUBLIC_URL + '/images/decama-logo.png'}
            />

            <Box
              component="img"
              alt="Org Image"
              src={process.env.PUBLIC_URL + '/images/blank.png'}
            />
          </Toolbar>
        </AppBar>
        <div className="pageContainer" style={disableOnTrue(isLoading)}>
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingLeft: '20px',
              paddingRight: '20px',
              zIndex: '10',
            }}
          >
            <Box noValidate className="loginbox" sx={{ mt: 1 }}>
              <div style={{ fontWeight: '500', fontSize: '28px' }}>
                {getHeadingText()}
              </div>
              <div style={{ fontWeight: '500', fontSize: '16px' }}>
                {getSubHeadingText()}
              </div>
              <div className="clear-height">&nbsp;</div>
              {!emailConfirmed && (
                <>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    name="email"
                    type="email"
                    value={userEmail}
                    placeholder="Email Address"
                    autoComplete="email"
                    autoFocus
                    inputRef={textInputUser}
                    onChange={handleEmailChange}
                  />{' '}
                </>
              )}
              {emailConfirmed &&
                otpConfirmed &&
                !passwordConfirmed &&
                otpInitiationType === 2 && (
                  <>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      name="newpassword"
                      value={newPassword}
                      type="password"
                      id="newpassword"
                      placeholder="New password"
                      //autoComplete="current-password"
                      inputRef={textInputNewPassword}
                      onChange={handleNewPasswordChange}
                    />
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      name="confirmnewpassword"
                      value={confirmNewPassword}
                      type="password"
                      id="confirmnewpassword"
                      placeholder="Confirm new password"
                      //autoComplete="current-password"
                      inputRef={textInputConfirmNewPassword}
                      onChange={handleConfirmNewPasswordChange}
                    />
                  </>
                )}
              {emailConfirmed && !otpConfirmed && !passwordConfirmed && (
                <>
                  <div className=".css-md26zr-MuiInputBase-root-MuiOutlinedInput-root">
                    <MuiOtpInput
                      margin="normal"
                      length={6}
                      id="otptext"
                      name="otptext"
                      value={otp}
                      onChange={handleOTPChange}
                    />
                  </div>
                </>
              )}
              <Button
                type="button"
                fullWidth
                sx={{ mt: 3, mb: 2, color: 'white' }}
                onClick={() => {
                  tryOTPMFA();
                }}
                className="login-screen-button"
              >
                <span style={{ fontSize: '18px' }}>CONFIRM</span>
              </Button>

              <Grid container>
                <div className="clear-height">&nbsp;</div>
              </Grid>
            </Box>
            {emailConfirmed && !otpConfirmed && !passwordConfirmed && (
              <>
                <Link
                  sx={{
                    display:
                      displayResendButton && !timerDisplay ? 'block' : 'none',
                  }}
                  onClick={() => {
                    resendOTP();
                  }}
                >
                  Resend Code
                </Link>
                <Typography
                  sx={{
                    display: timerDisplay ? 'block' : 'none',
                    fontSize: '16px',
                    color: ' #58585a',
                  }}
                >
                  Resend in:{timeRemaining}
                </Typography>
              </>
            )}
          </Box>
        </div>

        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          className="bottom-mini-device"
        >
          <Link
            onClick={() => {
              cancelAction();
            }}
            justifyContent="center"
            style={{
              textDecoration: 'none',
              color: '#e26f8e',
              fontSize: '20px',
            }}
          >
            Cancel
          </Link>
        </Box>
      </Box>
      <Loader isLoading={isLoading} />
    </>
  );
}
export default InitiateOTP;
